import { render, staticRenderFns } from "./ProfilePrivacy.vue?vue&type=template&id=2539ffb2&scoped=true&"
import script from "./ProfilePrivacy.vue?vue&type=script&lang=js&"
export * from "./ProfilePrivacy.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePrivacy.vue?vue&type=style&index=0&id=2539ffb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2539ffb2",
  null
  
)

export default component.exports